import { jsx as _jsx } from "react/jsx-runtime";
import { mdiPlus } from '@mdi/js';
import Button from '@mui/material/Button';
import { orange } from '@mui/material/colors';
import { Icon } from '@mdi/react';
import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { defineStyles, theme } from '../../theme';
const styles = defineStyles({
    button: {
        color: orange[400],
        '&:hover': {
            backgroundColor: orange[50],
        },
    },
    disabled: {
        color: theme.vars.palette.grey[400],
    },
});
export const AddOrConditionButton = ({ onClick, disabled }) => (_jsx(Button, { disableRipple: true, disabled: disabled, variant: "text", onClick: onClick, startIcon: _jsx(Icon, { path: mdiPlus, size: 0.8 }), sx: { ...styles.button, ...(disabled && styles.disabled) }, children: _jsx(Typography, { variant: "subtitle2", component: "span", sx: { color: 'inherit' }, children: _jsx(FormattedMessage, { id: "tableFiltering.addOrCondition.button", defaultMessage: "Add OR condition" }) }) }));
//# sourceMappingURL=AddOrConditionButton.js.map